import React from 'react'
import { Modal, message } from 'antd';
import history from './history';

const confirm = Modal.confirm;

const redirectToSettingECCredential = () => {
    history.push('/setting/channel')
}

export const alertSuccess = (line1, line2, ok, cancel, okText) => {
    Modal.success({
        title: (
            <div>
                <p>{line1}</p>
                <p>{line2}</p>
            </div>
        ),
        onOk() {
            ok ? ok() : null
        },
        onCancel() {
            cancel ? cancel() : null
        },
        okText,
        autoFocusButton: null
    });
};

export const alertSplitSuccess = (line1, line2, line3, line4) => {
    Modal.success({
        title: line1,
        content: (
            <div>
                <p style={{ marginLeft: '15px', marginTop: '5px', marginBottom: '5px', fontSize: '16px' }}>{line2}</p>
                <p style={{ marginBottom: '5px', marginLeft: '30px' }}>{line3}</p>
                <p style={{ marginBottom: '5px', marginLeft: '30px' }}>{line4}</p>
            </div>
        ),
        autoFocusButton: null,
        className: "split-success-popup-container"
    })
}

export const alertError = (line1, line2, ok, cancel, okText) => {
    Modal.error({
        title: (
            <div>
                <p>{line1}</p>
                <p>{line2}</p>
            </div>
        ),
        onOk() {
            ok ? ok() : null
        },
        onCancel() {
            cancel ? cancel() : null
        },
        okText,
        autoFocusButton: null,
        width:500
    });
};

export const alertWarning = (line1, line2, ok, cancel, okText) => {
    Modal.warning({
        title: (
            <div>
                <p>{line1}</p>
                <p>{line2}</p>
            </div>
        ),
        onOk() {
            ok ? ok() : null
        },
        onCancel() {
            cancel ? cancel() : null
        },
        okText,
        autoFocusButton: null
    });
};

export const alertErrorForever = (mess) => {
    message.destroy()
    message.error(mess, 0);
};

export const destroyMessage = () => {
    message.destroy()
};

export const showConfirm = (line1, ok, cancel, line2) => {
    confirm({
        title: (
            <div>
                <p>{line1}</p>
                <p>{line2}</p>
            </div>
        ),
        onOk() {
            ok ? ok() : null
        },
        onCancel() {
            cancel ? cancel() : null
        },
        autoFocusButton: null
    });
}

export const confirmChangeItem = (line1, ok, cancel, line2) => {
    confirm({
        title: (
            <div>
                <p>{line1}</p>
                <p>{line2}</p>
            </div>
        ),
        onOk() {
            ok ? ok() : null
        },
        onCancel() {
            cancel ? cancel() : null
        },
        okText: "YES",
        cancelText: "NO",
        autoFocusButton: null
    });
}

export const dialogError = (line1, line2, content) => {
    Modal.error({
        title: (
            <div>
                <p>{line1}</p>
                <p>{line2}</p>
            </div>
        ),
        autoFocusButton: null,
        content,
    });
}

export const dialogConfirm = (params) => {
    Modal.confirm({
        title: params.message,
        cancelText: 'No',
        okText: 'Yes',
        autoFocusButton: null,
        onOk() {
            if (params.type === 'error_eCommerce') {
                redirectToSettingECCredential()
            }
        },
        onCancel() {
        },
    });
};

export const dialogSuccess = (params) => {
    Modal.success({
        title: params.message,
    });
};

export const dialogWarning = (params) => {
    Modal.warning({
        title: params.message,
        autoFocusButton: null
    });
};

export const dialogShowResult = (title, description, ok) => {
    let desc = []
    for(let i = 0; i < Object.keys(description).length; i++) {
        desc.push(
            <p key={i}>{description[Object.keys(description)[i]]}</p>
        )
    }
    Modal.success({
        title,
        content: (
            desc
        ),
        onOk() {
            ok ? ok() : null
        },
    });
}



// WEBPACK FOOTER //
// ./src/services/dialog.js